import { render, staticRenderFns } from "./GlobalQueryBuilderEditor.vue?vue&type=template&id=60e0f05e&scoped=true"
import script from "./GlobalQueryBuilderEditor.vue?vue&type=script&lang=js"
export * from "./GlobalQueryBuilderEditor.vue?vue&type=script&lang=js"
import style0 from "./GlobalQueryBuilderEditor.vue?vue&type=style&index=0&id=60e0f05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0f05e",
  null
  
)

export default component.exports